
import _ from "lodash";
import { DateTime } from "luxon";
import { Component, Prop, Vue } from "vue-property-decorator";
import { DisplayOVO } from "./vo/main.vo";

@Component
export default class TimeSale extends Vue {
  @Prop()
  display!: DisplayOVO;

  cloneDisplay = {} as DisplayOVO;
  
  // 남은 시간 interval 객체
  remainingTimeInterval!: NodeJS.Timeout;

  // 타임세일 남은 시간
  resetRemainingTime() {
    this.cloneDisplay.displayItems.forEach((displayItem) => {
      const endTime = DateTime.fromSQL(displayItem.virtualCategoryEndTime);
      const remainingTimeDuration = endTime.diffNow();

      if (remainingTimeDuration.as("second") > 0) {
        Vue.set(displayItem, "remainingTime", remainingTimeDuration.toFormat("hh:mm:ss"));
      } else {
        Vue.set(displayItem, "remainingTime", "");
      }
    });
  }
  onImageLoaded() {
    this.$emit("image-loaded");
  }

  created() {
    this.cloneDisplay = _.cloneDeep(this.display);
    this.remainingTimeInterval = setInterval(() => {
      this.resetRemainingTime();
    }, 1000);
  }

  beforeDestory() {
    clearInterval(this.remainingTimeInterval);
  }
}
